import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { Suspendable } from '@components';
import { ROUTES } from '@constants';

const CampaignActivityReport = Suspendable(
  lazy(() =>
    import('@modules/campaignActivityReport/controller/CampaignActivityReportController').then(
      (module) => ({
        default: module.default,
      })
    )
  )
);

const Bonuses = Suspendable(
  lazy(() =>
    import('@modules/playerBonuses/controller/PlayerBonusesController').then(
      (module) => ({
        default: module.default,
      })
    )
  )
);

const Offers = Suspendable(
  lazy(() =>
    import('@modules/playerOffers/controller/PlayerOffersController').then(
      (module) => ({
        default: module.default,
      })
    )
  )
);

const OfferDetails = Suspendable(
  lazy(() =>
    import('@modules/playerOffers/submodules/PlayerOfferDetails/controller/PlayerOfferDetailsController').then(
      (module) => ({
        default: module.default,
      })
    )
  )
);

export const CampaignActivityRoutes: RouteObject[] = [
  {
    element: <CampaignActivityReport />,
    path: ROUTES.CAMPAIGN_ACTIVITY_REPORT.ROOT,
  },
  {
    element: <Bonuses />,
    path: ROUTES.CAMPAIGN_ACTIVITY_REPORT.BONUSES,
  },
  {
    element: <Offers />,
    path: ROUTES.CAMPAIGN_ACTIVITY_REPORT.OFFERS,
  },
  {
    element: <OfferDetails />,
    path: ROUTES.CAMPAIGN_ACTIVITY_REPORT.OFFER_DETAILS,
  },
];
